import React, { useState, useEffect } from 'react'
import { Box, Grid, Modal, Button } from '@material-ui/core'
import MaterialTable from 'material-table'
import './crearFormulario.scss'
import DownloadIcon from '@mui/icons-material/Download'
import { DownloadAzureBlobStorageService } from '../../../services/AsistenciaTecnica/create'
import { getHistoryForm } from '../../../services/MonitoreoYEvaluacion/get'

export const ModalDetalleForm = (props) => {
  const { open, setOpen, IdFormulario, setIdFormulario, ProjectCode } = props
  const [data, setData] = useState([])

  const handleClose = () => {
    setOpen(false)
    setIdFormulario(null)
  }

  const getHistory = async () => {
    try {
      const response = await getHistoryForm(IdFormulario)
      setData(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const downloadPDF = async (id) => {
    try {
      const response = await DownloadAzureBlobStorageService(id)
      if (response.Success) {
        const byteCharacters = atob(response.Data.FileContents)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = `Formulario #${ProjectCode}`
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getHistory()
  }, [IdFormulario])

  // const data = [
  //   {
  //     Id: IdFormulario,
  //     date: '2-2-2022',
  //     user: 'raudalesw',
  //     action: 'Crear',
  //     comments: 'Si se puede',
  //   },
  // ]
  const columns = [
    // {
    //   title: 'Código',
    //   field: 'IdForm',
    //   sorting: true,
    //   filtering: true,
    //   cellStyle: { width: '10%' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Fecha',
      field: 'ActionDate',
      sorting: true,
      filtering: true,
      cellStyle: { width: '15%' },
      // headerStyle: { color: '#fff' },
      type: 'date',
    },
    {
      title: 'Tipo de Usuario',
      field: 'UserType',
      sorting: true,
      filtering: true,
      cellStyle: { width: '5%' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Usuario Creador',
      field: 'User',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Observaciones',
      field: 'Comment',
      sorting: true,
      filtering: true,
      // cellStyle: { width: '50%' },
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <section>
          <Box className="modalPYME">
            <h3 className="pymeTitle">
              Historial del formulario: {ProjectCode}{' '}
            </h3>

            <Grid container>
              <Grid item xs={12} sm={12} md={12} style={{ marginTop: '1%' }}>
                <MaterialTable
                  columns={columns}
                  data={data}
                  style={{ height: '50', width: '10' }}
                  actions={[
                    (rowData) =>
                      rowData.AttachedDocuments !== 'N'
                        ? {
                            icon: () => <DownloadIcon color="success" />,
                            tooltip: 'Descargar',
                            onClick: (event, rowData) => {
                              downloadPDF(rowData.IdAttachedDocument)
                            },
                          }
                        : null,
                  ]}
                  options={{
                    sorting: true,
                    search: true,
                    searchFieldAlignment: 'right',
                    searchAutoFocus: true,
                    searchFieldVariant: 'standard',
                    filtering: true,
                    paging: true,
                    pageSizeOptions: [5],
                    pageSize: 5,
                    paginationType: 'stepped',
                    showFirstLastPageButtons: false,
                    paginationPosition: 'bottom',
                    exportButton: true,
                    exportAllData: true,
                    exportFileName: 'TableData',
                    // addRowPosition: 'first',
                    actionsColumnIndex: -1,
                    selection: false,
                    showSelectAllCheckbox: false,
                    showTextRowsSelected: false,
                    selectionProps: (rowData) => ({
                      // disabled: rowData.age == null,
                      // color:"primary"
                    }),
                    // grouping: true,
                    columnsButton: false,
                    // rowStyle: (data, index) =>
                    //   index % 2 === 0 ? { background: '#f5f5f5' } : null,
                    rowStyle: {
                      height: '1px',
                      maxHeight: '2px',
                      padding: 0,
                    },

                    headerStyle: {
                      background: '#014b96',
                      color: '#fff',
                      height: '1px',
                    },
                  }}
                  localization={{
                    body: {
                      editRow: {
                        deleteText: '¿Está seguro de eliminar el registro?',
                      },
                      emptyDataSourceMessage: 'No hay registros a desplegar',
                    },
                    header: {
                      actions: 'Acción',
                    },
                    toolbar: {
                      searchPlaceholder: 'Buscar',
                    },
                  }}
                  title=" "
                />
              </Grid>
            </Grid>
            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={() => handleClose()}>
                Salir
              </Button>
            </Grid>
          </Box>
        </section>
      </Modal>
    </>
  )
}
